import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import { ChevronLeft, ChevronRight, ExpandLess, ExpandMore } from "@material-ui/icons";
import { ArrowLeft, ArrowRight, ArrowDropDown, ArrowDropUp } from "@material-ui/icons";

import { gCalColors, greys } from "@styles/color.styles";
import { classNames } from "@util/html.util";
import { onSpaceOrEnterKey } from "@util/html.util";
import { CWIDProps } from "@util/cw-id.util";

type Direction = "left" | "right" | "up" | "down";
export interface HoverableChevronProps {
  direction: Direction;
  onClick?: () => void;
  disabled?: boolean;
  useArrows?: boolean;
  "aria-label"?: string;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    width: 32,
    height: 32,

    borderRadius: "50%",
    transition: "background-color 250ms ease",
  },
  containerWithHover: {
    cursor: "pointer",

    "&:hover": {
      backgroundColor: gCalColors.iconHoverColor,
    },
  },
  chevron: {
    fill: gCalColors.iconStrokeAndFill,
  },
  chevronDisabled: {
    fill: greys.cloudyBlue,
  },
});

const getComponent = (direction: Direction, useArrows: boolean, className: string) => {
  let Component;
  if (useArrows) {
    switch (direction) {
      case "left":
        Component = ArrowLeft;
        break;
      case "right":
        Component = ArrowRight;
        break;
      case "up":
        Component = ArrowDropUp;
        break;
      case "down":
        Component = ArrowDropDown;
        break;
    }
  } else {
    switch (direction) {
      case "left":
        Component = ChevronLeft;
        break;
      case "right":
        Component = ChevronRight;
        break;
      case "up":
        Component = ExpandLess;
        break;
      case "down":
        Component = ExpandMore;
        break;
    }
  }

  return <Component className={className} />;
};

export const HoverableChevron = ({
  direction,
  onClick,
  disabled,
  useArrows,
  "cw-id": cwId,
  "aria-label": ariaLabel,
}: HoverableChevronProps & CWIDProps) => {
  const classes = useStyles();
  const chevronClassName = disabled ? classes.chevronDisabled : classes.chevron;

  const Component = getComponent(direction, !!useArrows, chevronClassName);

  return (
    <div
      cw-id={cwId}
      aria-label={ariaLabel}
      tabIndex={0}
      className={classNames([classes.container, !disabled && classes.containerWithHover])}
      onClick={disabled ? undefined : onClick}
      onKeyDown={disabled ? undefined : onSpaceOrEnterKey(onClick)}
    >
      {Component}
    </div>
  );
};
